export default __webpack_public_path__ + "static/media/31.2429fd66.png";